/**
 * Thin fetch() wrappers for the backend API endpoints.
 */

import type {
  StartSessionRequest,
  StartSessionResponse,
  GetSessionResponse,
  ReconnectRequest,
  ReconnectResponse,
} from "@shared/types";

const HEADERS = { "Content-Type": "application/json" };

export async function startSession(
  req: StartSessionRequest
): Promise<StartSessionResponse> {
  const res = await fetch("/api/session/start", {
    method: "POST",
    headers: HEADERS,
    body: JSON.stringify(req),
  });
  if (!res.ok) throw new Error(`Start session failed: ${res.status}`);
  return res.json();
}

export async function getSession(
  sg: string,
  arn: string
): Promise<GetSessionResponse> {
  const res = await fetch(
    `/api/session/${encodeURIComponent(sg)}/${encodeURIComponent(arn)}`
  );
  if (!res.ok) throw new Error(`Get session failed: ${res.status}`);
  return res.json();
}

export async function reconnectSession(
  req: ReconnectRequest
): Promise<ReconnectResponse> {
  const res = await fetch("/api/session/reconnect", {
    method: "POST",
    headers: HEADERS,
    body: JSON.stringify(req),
  });
  if (!res.ok) throw new Error(`Reconnect failed: ${res.status}`);
  return res.json();
}

export async function terminateSession(sessionArn: string): Promise<void> {
  const res = await fetch("/api/session/terminate", {
    method: "POST",
    headers: HEADERS,
    body: JSON.stringify({ sessionArn }),
  });
  if (!res.ok) throw new Error(`Terminate failed: ${res.status}`);
}
